module.exports = __webpack_public_path__ + "img/mobile.234a70d5.jpg";